import React, { useState, useEffect, useRef, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import DetailsPageCard from '../../common/DetailsPage/DetailsPageCard';
import CustomModal from '../../../components/common/CustomModal';
import { DELETE_ORDER_PLANNING, GET_PRODUCTS_LIST, GET_SUPPLIERS_LIST, LIST_ALL_ORDER_PLANNING, } from '../../../services/apiRoutes';
import { costColorPlate } from '../../../constants/DetailsPage';
import { useShipmentDetails } from './useShipmentDetails';
import MessageBox from '../../common/CustomMessageBox';
import CustomDelete from '../../common/CustomDeleteAlert';
import { getContactPersonList, getCurrencyList, getRoundAmount } from '../../../services/CommonServices';
import axios from 'axios';
import { genericPost } from '../../../services/authServices';
import CustomLoader from '../../common/CustomLoader';
import { Box } from '@mui/material';
import { AuthContext } from '../../../context/AuthContext';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import CustomStatus from '../../common/CustomStatus';
import { useCompanyDateFormat } from "../../../constants/useCompanyDateFormat";
import ViewOrderPlanning from '../../OrderPlanning/ViewOrderPlanning';
import UpdateOrderPlanning from '../../OrderPlanning/UpdateOrderPlanning';


const OrderPlanningImport = ({ fetchButtonList }) => {
    const { token } = useContext(AuthContext)
    const companyDateFormat = useCompanyDateFormat();
    const [open, setOpen] = useState(true);
    const [modal, setModal] = useState(false);
    const [loading, setLoading] = useState(true);
    const [dataLoaded, setDataLoaded] = useState(false);
    const [deleteAlert, setDeleteAlert] = useState(false)
    const [rowId, setRowId] = useState('')
    const [data, setData] = useState([]);
    const [error, setError] = useState(null);
    const { importShipmentId } = useParams();
    const [suppliersList, setSuppliersList] = useState([]);
    const [contactPersonList, setContactPersonList] = useState([]);
    const [currencyList, setCurrencyList] = useState([]);
    const [products, setProducts] = useState([]);
    const [message, setMessage] = useState({
        open: false,
        text: '',
        type: ''
    });
    const [updateModal, setUpdateModal] = useState(false);
    const [viewModal, setViewModal] = useState(false);
    const [activeTab, setActiveTab] = useState('OrderPlanning');
    const [updateCompleted, setUpdateCompleted] = useState(false); // New state to track modal closure
    const [newShippingId, setNewShippingId] = useState(null);
    const [selectedOrderPlanningId, setSelectedOrderPlanningId] = useState("");

    const navigate = useNavigate();

    const { shipmentDetails, loading: shipmentLoading } = useShipmentDetails(importShipmentId);

    let supplierId, cifFob, cifFobColor, cifFobBgColor;

    const hasFetched = useRef(false);
    useEffect(() => {
        if (shipmentDetails) {
            supplierId = shipmentDetails.supplierId;
            cifFob = shipmentDetails.cifFob.cifFobName;
            cifFobColor = shipmentDetails?.cifFob?.ColorPlate?.color ?? '';
            cifFobBgColor = shipmentDetails?.cifFob?.ColorPlate?.backgroundColor ?? '';
            fetchData();
            getCommonData();
            fetchProductsList();
            getSuppliersList();
            hasFetched.current = true;
        }
    }, [shipmentDetails, updateCompleted, updateModal, modal, deleteAlert, token,]);


    const fetchProductsList = async () => {
        const authToken = sessionStorage.getItem('accessToken');
        const payload = {
            clientCompanyId: supplierId,
        };

        try {
            const response = await axios.post(GET_PRODUCTS_LIST, payload, {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });

            if (response.status === 200 && response.data.success) {
                const productData = response.data.productsList;
                console.log(productData);
                setProducts(productData);
            } else {
                console.error('Failed to fetch products list:', response.data);
            }
        } catch (error) {
            console.error('Error fetching products list:', error);
        }
    };


    const getSuppliersList = async () => {
        try {
            const payload = {
                clientCompanyId: supplierId,
            };
            const response = await genericPost(GET_SUPPLIERS_LIST, payload, {
            });
            if (response.data && response.data.success && response.data.clientCompanies) {
                const suppliersData = response.data.clientCompanies.map((supplier) => ({
                    id: supplier.clientCompanyId,
                    title: supplier.clientCompanyName,
                }));
                setSuppliersList(suppliersData);

            } else {
                return [];
            }
        } catch (error) {
            console.error('Error fetching suppliers list:', error);
            return [];
        }
    };

    const fetchData = async () => {
        setLoading(true);
        try {
            const payload = {
                clientId: supplierId,
                shipmentOrgId: shipmentOrgId,
            };
            const response = await genericPost(
                LIST_ALL_ORDER_PLANNING,
                payload,
                {}
            );
            if (response?.data?.orderPlanning) {
                const orderPlanningData = response.data.orderPlanning.map(
                    (item, index) => {
                        const statusObj = statusList.find(
                            (status) => status.id === String(item.status)
                        );
                        const orderTypeObj = orderTypeList.find(
                            (type) => type.id === String(item.commanShipmentId)
                        );
                        const particulars =
                            item.particulars?.map((particular) => {
                                const qty = Number(particular.qty) || 0;
                                const rate = Number(particular.rate) || 0;
                                return {
                                    ...particular,
                                    product: particular.products?.productName || "",
                                    unitName:
                                        particular.productsUnit?.unitName || "",
                                    fclName: particular.fcl?.fclName || "",
                                    qty,
                                    rate,
                                    amount: qty * rate,
                                };
                            }) || [];
                        const totalAmount = getRoundAmount(
                            particulars.reduce(
                                (total, current) => total + current.amount,
                                0
                            )
                        );
                        return {
                            ...item,
                            index: (index + 1).toString().padStart(2, "0"),
                            id: item.orderPlanningId || "",
                            orderPlanningId: item.orderPlanningId || "",
                            companyId: item.companyId || "",
                            userId: item.userId || "",
                            orderNo: item.orderNo || "",
                            commanShipmentId: item.commanShipmentId || "",
                            shipmentId: item.shipmentId || "",
                            clientId: item.clientId || "",
                            clientName:
                                item.client?.clientCompanyName || "",
                            currencyId: item.currencyId || "",
                            currency:
                                item.currency
                                    ? `${item.currency.currency_symbol} ${item.currency.currency_name}`
                                    : "",
                            currencyName:
                                item.currency?.currency_name || "",
                            currencySymbol:
                                item.currency?.currency_symbol || "",
                            status: item.status || "",
                            statusTitle: statusObj?.title || "",
                            orderTypeTitle: orderTypeObj?.title || "",
                            date: companyDateFormat(item.date) || "",
                            eTD: companyDateFormat(item.eTD) || "",
                            eTA: companyDateFormat(item.eTA) || "",
                            notes: item.notes || "",
                            createdAt:
                                companyDateFormat(item.createdAt) || "",
                            updatedAt:
                                companyDateFormat(item.updatedAt) || "",
                            particulars,
                            totalAmount,
                            totalAmountDisplay: `${item.currency?.currency_symbol || ""
                                } ${totalAmount.toFixed(2)}`,
                        };
                    }
                );
                setData(orderPlanningData);
            } else {
                setData([]);
                setError("No order planning data found.");
            }
        } catch (error) {
            console.error("Error fetching order planning:", error);
            setData([]);
            setError("Error fetching order planning.");
        } finally {
            setLoading(false);
            setDataLoaded(true);
        }
    };


    const handleDelete = async (orderPlanningId) => {
        setLoading(true);

        const authToken = sessionStorage.getItem("accessToken");

        try {
            const response = await axios.delete(
                DELETE_ORDER_PLANNING(orderPlanningId),
                {
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );

            if (response.status === 200) {
                setDeleteAlert(false);
                setRowId("");

                fetchButtonList();
                fetchData();

                setMessage({
                    open: true,
                    text: "Order Planning deleted successfully.",
                    type: "success",
                });
            }
        } catch (error) {
            console.error("Error deleting Order Planning:", error);

            setMessage({
                open: true,
                text:
                    error?.response?.data?.error ||
                    "Failed to delete Order Planning.",
                type: "error",
            });
        } finally {
            setLoading(false);
        }
    };
    const getCommonData = async () => {
        const contactPersonList = await getContactPersonList();
        setContactPersonList(contactPersonList);
        const currencyListData = await getCurrencyList();
        setCurrencyList(currencyListData);
    }
    const handleOpenDeleteAlert = (orderPlanningId) => {
        setRowId(orderPlanningId);
        setDeleteAlert(true);
    };
    const handleOpenModal = () => {
        setModal(true);
    };

    const handleCloseModal = () => {
        setModal(false);
    };

    const handleViewClick = (id) => {
        handleOpenView(id);
    };

    const handleUpdateClick = (id) => {
        handleOpenUpdate(id);
    };

    const handleOpenView = (id) => {
        setSelectedOrderPlanningId(id);
        setViewModal(true);
    };
    const handleCloseView = () => {
        setViewModal(false);
        setSelectedOrderPlanningId("");
        setUpdateCompleted(true);
    };
    const handleOpenUpdate = (id) => {
        setSelectedOrderPlanningId(id);
        setUpdateModal(true);
    };
    const handleCloseUpdate = () => {
        setUpdateModal(false);
        setSelectedOrderPlanningId("");
        setUpdateCompleted(true);
    };
    if (!shipmentDetails) {
        return (
            <Box>
                <CustomLoader open={shipmentLoading} />
            </Box>
        );
    }

    const OrderPlanningColumns = [
        {
            id: "index",
            label: "SN",
            accessor: "index",
            styleAccessor: {
                textAlign: "center",
                width: "60px",
            },
        },
        {
            id: "date",
            label: "Date",
            accessor: "date",
            styleAccessor: { textAlign: "center" },
        },
        {
            id: "shipmentId",
            label: "Shipment ID",
            accessor: "shipmentId",
            styleAccessor: { textAlign: "center" },
        },
        {
            id: "orderNo",
            label: "Order No",
            accessor: "orderNo",
            styleAccessor: { textAlign: "center" },
        },
        {
            id: "eTD",
            label: "ETD",
            accessor: "eTD",
            styleAccessor: { textAlign: "center" },
        },
        {
            id: "eTA",
            label: "ETA",
            accessor: "eTA",
            styleAccessor: { textAlign: "center" },
        },

        {
            id: "totalAmountDisplay",
            label: "Amount",
            accessor: "totalAmountDisplay",
            styleAccessor: {
                textAlign: "right",
            },
        },
        {
            id: "status",
            label: "Status",
            accessor: "status",
            styleAccessor: {
                textAlign: "center",
            },
            Cell: ({ row }) => (
                <CustomStatus
                    title={row.status === "1" ? "Active" : "Inactive"}
                    sx={{
                        backgroundColor:
                            row.status === "1" ? "#E8F5E9" : "#FDECEC",
                        color:
                            row.status === "1" ? "#2E7D32" : "#D32F2F",
                        border: `1px solid ${row.status === "1" ? "#2E7D32" : "#D32F2F"
                            }`,
                        width: "70px",
                        display: "inline-block",
                        textAlign: "center",
                    }}
                />
            ),
        },
        {
            id: "action",
            label: "Action",
            accessor: "action",
            Cell: ({ row }) => (
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 2,
                    }}
                >
                    <IconButton
                        onClick={() => handleViewClick(row.orderPlanningId)}
                    >
                        <VisibilityIcon sx={{ color: "#059212" }} />
                    </IconButton>

                    <IconButton
                        onClick={() => handleUpdateClick(row.orderPlanningId)}
                    >
                        <ModeEditOutlineOutlinedIcon sx={{ color: "#050C9C" }} />
                    </IconButton>

                    <IconButton
                        onClick={() =>
                            handleOpenDeleteAlert(row.orderPlanningId)
                        }
                    >
                        <DeleteOutlineOutlinedIcon sx={{ color: "#E4003A" }} />
                    </IconButton>
                </div>
            ),
        },
    ];

    const purchasePrefixActivity = shipmentDetails.company.purchasePrefixActivity ?? '';
    const purchasePrefix = (purchasePrefixActivity === 1)
        ? shipmentDetails.company.purchasePrefix
        : (purchasePrefixActivity === 0 ? '' : '');

    const purchaseSuffixActivity = shipmentDetails.company.purchaseSuffixActivity ?? '';
    const purchaseSuffix = (purchaseSuffixActivity === 1)
        ? shipmentDetails.company.purchaseSuffix
        : (purchaseSuffixActivity === 0 ? '' : '');
    const companyName = shipmentDetails.supplier.clientCompanyName;
    const phoneNumber = shipmentDetails.supplier.mobile;
    const supplierIdName = shipmentDetails.supplierId;
    const shipmentId = shipmentDetails.shipmentId;
    const shipmentOrgId = shipmentDetails.importShipmentId;
    const cifFobId = shipmentDetails.cifFobId && shipmentDetails.cifFobId !== '' ? shipmentDetails.cifFobId : '';

    const countryName = shipmentDetails?.currency?.name ?? '';
    const currencySymbol = shipmentDetails?.currency?.currency_symbol ?? '';
    const currencyShort = shipmentDetails?.currency?.currency ?? '';
    const currency = `${currencySymbol} ${currencyShort} ${countryName}`;
    const currencyId = shipmentDetails?.currency?.id ?? '';
    const templateId = shipmentDetails?.company?.purchaseTemplateId ?? '1';

    return (
        <div>

            <DetailsPageCard
                Icon={ShoppingCartOutlinedIcon}
                columns={OrderPlanningColumns}
                title={'Order Planning'}
                // buttonTitle={'Create Order Planning'}
                handleOpen={handleOpenModal}
                data={data}
                loading={loading}
                error={error}
            />

            <CustomModal open={updateModal}>
                <UpdateOrderPlanning
                    handleClose={handleCloseUpdate}
                    selectedId={selectedOrderPlanningId}
                    suppliersList={suppliersList}
                    currencyList={currencyList}
                    statusList={statusList}
                    orderTypeList={orderTypeList}
                    fetchData={fetchData}
                    setMessage={setMessage}
                />
            </CustomModal>
            <CustomModal open={viewModal}>
                <ViewOrderPlanning
                    handleClose={handleCloseView}
                    selectedId={selectedOrderPlanningId}
                    statusList={statusList}
                    orderTypeList={orderTypeList}
                />
            </CustomModal>

            <MessageBox
                open={message.open}
                onClose={() => setMessage({ ...message, open: false })}
                message={message.text}
                handleClose={() => setMessage({ ...message, open: false })}
                type={message.type}
            />
            <CustomDelete
                handleDelete={handleDelete}
                open={deleteAlert}
                rowId={rowId}
                handleClose={() => setDeleteAlert(false)}
            />

        </div>
    );
};

export default OrderPlanningImport;


const statusList = [
    { id: "1", title: "Active" },
    { id: "2", title: "Hold" },
    { id: "3", title: "Cancel" }
];
const orderTypeList = [
    { id: "0", title: "Import Order" },
    { id: "1", title: "Export Order" }
];
const getStatusStyle = (status) => {
    switch (status) {
        case "Active":
            return {
                backgroundColor: "#E8F5E9", // Light Green
                color: "#1B5E20",
                border: "1px solid #81C784",
            };

        case "Hold":
            return {
                backgroundColor: "#FFF8E1", // Light Amber
                color: "#E65100",
                border: "1px solid #FFCC80",
            };

        case "Cancel":
            return {
                backgroundColor: "#FDECEC", // Light Red
                color: "#B71C1C",
                border: "1px solid #EF9A9A",
            };

        default:
            return {
                backgroundColor: "#F5F5F5",
                color: "#424242",
                border: "1px solid #E0E0E0",
            };
    }
};

const getOrderTypeStyle = (type) => {
    switch (type) {
        case "Import Order":
            return {
                backgroundColor: "#E3F2FD", // Light Blue
                color: "#0D47A1",
                border: "1px solid #90CAF9",
            };

        case "Export Order":
            return {
                backgroundColor: "#F3E5F5", // Light Purple
                color: "#6A1B9A",
                border: "1px solid #CE93D8",
            };

        default:
            return {
                backgroundColor: "#F5F5F5",
                color: "#424242",
                border: "1px solid #E0E0E0",
            };
    }
};


